import { render, staticRenderFns } from "./your-desk-a45.vue?vue&type=template&id=1578b440"
import script from "./your-desk-a45.vue?vue&type=script&lang=js"
export * from "./your-desk-a45.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports